import { getDateInstanceWithZeroUTCTimeFromDateString } from "framework/helpers";
function fromApiTransportDate(value) {
    return value ? getDateInstanceWithZeroUTCTimeFromDateString(value) : undefined;
}
function fromApiTransportDateTimeOffset(value) {
    return value ? new Date(value) : undefined; // YYYY-MM-ddTHH:mm:ss expected
}
function intoApiTransportDate(value) {
    var _a;
    var isoDate = value === null || value === void 0 ? void 0 : value.toISOString();
    return (_a = isoDate === null || isoDate === void 0 ? void 0 : isoDate.slice(0, 10)) !== null && _a !== void 0 ? _a : undefined;
}
function intoApiTransportDateTimeOffset(value) {
    var _a;
    return (_a = value === null || value === void 0 ? void 0 : value.toISOString()) !== null && _a !== void 0 ? _a : undefined;
}
export { fromApiTransportDate, fromApiTransportDateTimeOffset, intoApiTransportDate, intoApiTransportDateTimeOffset };
